const STORAGE_TOKEN_KEY = 'BIGGBY_USER_KEY';

const setUserSession = (userSession: AuthState): void => {
	if (userSession) {
		deleteAccessToken();
		localStorage.setItem(STORAGE_TOKEN_KEY, JSON.stringify(userSession));
		return;
	}
};

const getAccessToken = (): string | null | undefined => {
	try {
		const userSession = localStorage.getItem(STORAGE_TOKEN_KEY);
		if (userSession) {
			const result = JSON.parse(userSession) as AuthState;
			const token = result.accessToken;
			return token;
		}
		return null;
	} catch (error) {
		return null;
	}
};

const getUserSession = (): AuthState | null | undefined => {
	try {
		const userSession = localStorage.getItem(STORAGE_TOKEN_KEY);
		if (userSession) {
			const result = JSON.parse(userSession) as AuthState;
			const token: AuthState = {
				id: result.id,
				accessToken: result.accessToken,
				refreshToken: result.refreshToken
			};
			return token;
		}
		return null;
	} catch (error) {
		return null;
	}
};

const deleteAccessToken = (): boolean => {
	try {
		localStorage.removeItem(STORAGE_TOKEN_KEY);
		return true;
	} catch (error) {
		return false;
	}
};

export {
	setUserSession,
	getAccessToken,
	getUserSession,
	deleteAccessToken,
	STORAGE_TOKEN_KEY
};
